<div class="auth-wrapper">
    <div class="row body">
        <h1>Ingresar</h1>
        
        <img src="./assets/img/logo-libresalud-cuadrado.png" alt="Libre Salud" class="logo mb-5">
        
        @if (sessionError() === 'offline') {
            <div class="alert alert-warning d-flex align-items-center justify-content-between mb-3" role="alert">
                <small>Sin conexión a internet. Conectate e intentá de nuevo.</small>
                <button type="button" class="btn btn-sm btn-warning ms-2" (click)="retry()" [disabled]="loading()">Reintentar</button>
            </div>
        }
        @if (sessionError() === 'data-load-failed') {
            <div class="alert alert-warning d-flex align-items-center justify-content-between mb-3" role="alert">
                <small>No se pudieron cargar tus datos. Por favor intentá de nuevo.</small>
                <button type="button" class="btn btn-sm btn-warning ms-2" (click)="retry()" [disabled]="loading()">Reintentar</button>
            </div>
        }

        <form (ngSubmit)="login()" [formGroup]="loginUsuario">
            <div class="mb-3 mt-1 text-start form-floating">
                <input type="email" class="form-control" id="email" aria-describedby="emailHelp" formControlName="email" placeholder="ejemplo@email.com">
                <label for="email" class="form-label">Email</label>
                @if (loginUsuario.controls.email.invalid
                    && (loginUsuario.controls.email.dirty || loginUsuario.controls.email.touched)
                    && loginUsuario.controls.email.errors?.['required']) {
                    <div class="alert-danger" role="alert"><small class="alert">Email es requerido</small></div>
                }

                @if (loginUsuario.controls.email.invalid
                        && loginUsuario.controls.email.touched
                        && loginUsuario.controls.email.errors?.['email']) {
                    <div class="alert-danger" role="alert"><small class="alert">Email inválido</small></div>
                }
            </div>
            <div class="text-start form-floating mb-1">
                <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" id="clave" formControlName="clave" placeholder="Ingrese su clave" />
                <label for="clave" class="form-label">Contraseña</label>
                <i class="bi seePassword"
                    [class.bi-eye-slash]="!fieldTextType"
                    [class.bi-eye]="fieldTextType"
                    (click)="toggleFieldTextType()">
                </i>
            </div>
            <div class="mb-5 form-check text-start">
                <input type="checkbox" class="form-check-input" id="recordarme" formControlName="recordarme">
                <label class="form-check-label" for="recordarme">Recordarme</label>
            </div> 

            @if (error()) {
                <div class="alert alert-danger" role="alert"><small>{{ error() }}</small></div>
            }
            @if (success()) {
                <div class="alert alert-success" role="alert"><small>{{ success() }}</small></div>
            }
            <!-- <div class="row mb-1 p-2">
                <p class="col text-start tyc">Al continuar aceptás los <a routerLink="/terminos-condiciones">Términos y condiciones</a>.</p>
            </div> -->
            <div class="d-grid mt-0 mb-2">
                <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
                    {{(loading()) ? 'Cargando...' : 'Ingresar'}}
                </button>
            </div>
            <div class="row mb-2 p-2 text-start">
                <small class="recover-password"><a routerLink="/recover-password">Olvidé mi contraseña</a></small>
            </div>
            @if (showBioButton()) {
                <div class="mb-4">
                    <button type="button" class="bio-btn" (click)="loginWithBiometrics()">
                    @if (biometryKind() === 'face') {
                        <img src="./assets/img/faceid.png" class="bio-icon bio-icon-img" alt="Face ID">
                    } @else {
                        <i class="bi bi-fingerprint bio-icon bio-icon-i"></i>
                    }
                    </button>
                </div>
            }
            <!--<div class="d-grid gap-2">
                <button type="button" class="btn btn-light btn-lg btn-outline-dark text-white" (click)="loginGoogle()"><span class="bi-google"></span> Continuar con Google</button>
            </div>-->
            <hr class="hr border-white opacity-30 ">

            <p class="mt-3 text-link-small btn-register"><a [routerLink]="['/sign-up', 2]">Crear una nueva cuenta</a></p>
        </form>
    </div>
</div>